(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-slider-auto-loading"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    new Swiper(".blog-blocks-slider", {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: { slidesPerView: 1 },
        1024: { slidesPerView: 3 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    new Swiper(".blog-blocks-slider", {
      slidesPerView: 1,
      spaceBetween: 12,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        768: { slidesPerView: 1 },
        1024: { slidesPerView: 3 }
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brands-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brands-library')) {
    customElements.define(
      'brands-library',
      class BrandsLibrary extends HTMLElement {
        /** Case- and accent-insensitive, so "dolce" finds "DOLCE & GABBANA" and "celine" finds "CÉLINE". */
        static normalize(text) {
          return String(text || '')
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .toLowerCase()
            .trim();
        }

        connectedCallback() {
          this.querySelector('[data-brands-search]')?.addEventListener('input', (event) => {
            this.filter(/** @type {HTMLInputElement} */ (event.target).value);
          });
        }

        /** @param {string} value */
        filter(value) {
          const query = BrandsLibrary.normalize(value);
          let shown = 0;

          for (const group of this.querySelectorAll('[data-brands-group]')) {
            let groupShown = 0;

            for (const item of group.querySelectorAll('[data-brand-name]')) {
              const matches = !query || BrandsLibrary.normalize(item.getAttribute('data-brand-name')).includes(query);
              item.hidden = !matches;
              if (matches) groupShown += 1;
            }

            group.hidden = groupShown === 0;
            this.querySelector(`[data-brands-letter="${CSS.escape(group.getAttribute('data-brands-group') || '')}"]`)
              ?.toggleAttribute('aria-disabled', groupShown === 0);
            shown += groupShown;
          }

          const noMatch = this.querySelector('[data-brands-no-match]');
          if (noMatch) noMatch.hidden = shown > 0;
        }
      }
    );
  }
  if (!customElements.get('brands-carousel')) {
    customElements.define(
      'brands-carousel',
      class BrandsCarousel extends HTMLElement {
        #timer = 0;
        #paused = false;

        connectedCallback() {
          this.track = this.querySelector('[data-carousel-track]');
          if (!this.track) return;

          this.querySelector('[data-carousel-prev]')?.addEventListener('click', () => this.step(-1));
          this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.step(1));
          new ResizeObserver(() => this.update()).observe(this.track);

          // Hold still while the shopper is looking at or using it.
          for (const type of ['pointerenter', 'focusin', 'touchstart']) {
            this.addEventListener(type, () => (this.#paused = true), { passive: true });
          }
          for (const type of ['pointerleave', 'focusout']) {
            this.addEventListener(type, () => (this.#paused = false));
          }

          this.update();
          this.#autoplay();
        }

        disconnectedCallback() {
          window.clearInterval(this.#timer);
        }

        /** One card to the left or right; past either end it wraps around. */
        step(direction) {
          const card = this.track.querySelector('li');
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const width = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
          const max = this.track.scrollWidth - this.track.clientWidth;

          let left = this.track.scrollLeft + direction * width;
          if (direction > 0 && this.track.scrollLeft >= max - 2) left = 0;
          if (direction < 0 && this.track.scrollLeft <= 2) left = max;

          this.track.scrollTo({ left, behavior: 'smooth' });
        }

        /** Arrows only when there is something to scroll to. */
        update() {
          const controls = this.querySelector('[data-carousel-controls]');
          if (controls) controls.hidden = this.track.scrollWidth - this.track.clientWidth <= 2;
        }

        #autoplay() {
          if (this.dataset.autoplay !== 'true') return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          const interval = Math.max(2, Number(this.dataset.interval) || 4) * 1000;
          this.#timer = window.setInterval(() => {
            if (this.#paused || document.hidden) return;
            if (this.track.scrollWidth - this.track.clientWidth <= 2) return;
            this.step(1);
          }, interval);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-blocks"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  if (typeof Swiper !== "undefined") {
    new Swiper(".slider-group-blocks", {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
  0: {
    slidesPerView: 1.2,
    spaceBetween: 15,
    centeredSlides: false,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    freeMode: false, // IMPORTANT - disable free mode
    watchSlidesProgress: true,
    slideToClickedSlide: false
  },
  768: {
    slidesPerView: 4,
    spaceBetween: 20
  }
}
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
